import { View, Text, styled } from 'tamagui'
import { ShieldAlert } from '@tamagui/lucide-icons'
import { useAppStore } from '@/store'

const Container = styled(View, {
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  gap: 16,
  padding: 32,
})

const Heading = styled(Text, {
  fontFamily: '$fontHeading',
  fontWeight: '700',
  fontSize: 20,
  color: '$surfaceForeground',
})

const Description = styled(Text, {
  fontFamily: '$fontBody',
  fontSize: 14,
  color: '$sidebarMuted',
  textAlign: 'center',
  maxWidth: 360,
  lineHeight: 20,
})

const ButtonRow = styled(View, {
  flexDirection: 'row',
  gap: 12,
  marginTop: 8,
})

const GoBackButton = styled(View, {
  paddingHorizontal: 20,
  paddingVertical: 10,
  borderRadius: '$borderRadiusMd',
  borderWidth: 1,
  borderColor: '$borderDefault',
  cursor: 'pointer',
  hoverStyle: { backgroundColor: '$sidebarHover' },
  // @ts-expect-error -- web transition
  style: { transition: 'background-color 150ms ease' },
})

const ConfirmButton = styled(View, {
  paddingHorizontal: 20,
  paddingVertical: 10,
  borderRadius: '$borderRadiusMd',
  backgroundColor: '$error',
  cursor: 'pointer',
  hoverStyle: { opacity: 0.9 },
  // @ts-expect-error -- web transition
  style: { transition: 'opacity 150ms ease' },
})

const ButtonText = styled(Text, {
  fontFamily: '$fontBody',
  fontSize: 14,
  fontWeight: '600',
})

interface NsfwGateProps {
  channelId: string
}

export function NsfwGate({ channelId }: NsfwGateProps) {
  const { acknowledgeNsfwChannel, setActiveChannel } = useAppStore()

  return (
    <Container>
      <ShieldAlert size={48} color="$error" />
      <Heading>Age-Restricted Channel</Heading>
      <Description>
        This channel is marked as NSFW. You must confirm that you are of legal age to view this content.
      </Description>
      <ButtonRow>
        <GoBackButton onPress={() => setActiveChannel('ch3')}>
          <ButtonText color="$sidebarMuted">Go Back</ButtonText>
        </GoBackButton>
        <ConfirmButton onPress={() => acknowledgeNsfwChannel(channelId)}>
          <ButtonText color="$surfaceForeground">I understand</ButtonText>
        </ConfirmButton>
      </ButtonRow>
    </Container>
  )
}
